
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedPost from './components/FeaturedPost';
import BlogGrid from './components/BlogGrid';
import CategoriesSection from './components/CategoriesSection';

export default function Blog() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturedPost />
        <BlogGrid />
        <CategoriesSection />
      </main>
      <Footer />
    </div>
  );
}